import type { Recipient, RecipientStatusFilter } from '../types';

export function filterRecipients(
  recipients: Recipient[],
  search: string,
  statusFilter: RecipientStatusFilter
): Recipient[] {
  const query = search.trim().toLowerCase();

  return recipients.filter((recipient) => {
    const matchesStatus = statusFilter === 'todos' || recipient.status === statusFilter;
    if (!matchesStatus) return false;
    if (!query) return true;

    return (
      recipient.name.toLowerCase().includes(query) ||
      recipient.email.toLowerCase().includes(query)
    );
  });
}
